import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Company } from '../models/company.model';
import { IService } from '../models/service.interface';
import { FirestoreService } from './firestore.service';

const itemCollection = 'companies';

@Injectable({
  providedIn: 'root',
})
export class CompaniesService implements IService<Company> {
  constructor(
    private firestore: FirestoreService,
  ) { }

  async save(item: Company) {
    return this.firestore.save(itemCollection, item);
  }

  async update(item: Company) {
    return this.firestore.update(itemCollection, item);
  }

  get(_guid: string): Observable<Company> {
    throw Error('Not implemented get feedback');
  }

  getList(_options?: {}): Observable<Company[]> {
    const queryConstraints = [];


    return this.firestore.getList<Company>(itemCollection, undefined, queryConstraints);
  }
}
